import { render, staticRenderFns } from "./download-popup.vue?vue&type=template&id=4c4a39c8"
import script from "./download-popup.vue?vue&type=script&lang=js"
export * from "./download-popup.vue?vue&type=script&lang=js"
import style0 from "./download-popup.vue?vue&type=style&index=0&id=4c4a39c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports